import { render } from "./SidebarButton.vue?vue&type=template&id=a9b5a896&scoped=true"
import script from "./SidebarButton.vue?vue&type=script&lang=js"
export * from "./SidebarButton.vue?vue&type=script&lang=js"

import "./SidebarButton.vue?vue&type=style&index=0&id=a9b5a896&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9b5a896"]])

export default __exports__